import CryptoJS from "crypto-js";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ResponseHandlerName } from "common/responseHandlerService/model";
import ApiIndicesPerformanceSummary from "integration/api/ApiIndicesPerformanceSummary";
import { RootState } from "application/store";
import { IndicesPerformanceSummaryState } from "./models";

class IndicesPerformanceSummaryActions {
  static getDataForFilters = createAsyncThunk(
    `indices-summary/${ResponseHandlerName.GetIndicesPerformanceSummaryFilters}`,
    async (_, { rejectWithValue }) => {
      try {
        const res =
          await ApiIndicesPerformanceSummary.getIndicesPerformanceSummaryFilters();
        return res.data;
      } catch (error) {
        console.log("getIndicesPerformanceSummaryFilters Error: ", error);
        return rejectWithValue(error);
      }
    }
  );

  static decryptData = (data: string) => {
    const key = process.env.REACT_APP_CRYPTO_JS_KEY || "";
    const decryptedData = CryptoJS.AES.decrypt(data, key).toString(
      CryptoJS.enc.Utf8
    );
    return JSON.parse(decryptedData);
  };

  static getIndicesPerformanceSummaryData = createAsyncThunk(
    `indices-summary/${ResponseHandlerName.GetIndicesPerformanceSummary}`,
    async (_, { rejectWithValue, getState }) => {
      const { filters } = (getState() as RootState).indicesPerformanceSummary;
      const metric = filters.selectedMetric.code;
      const endingDate = filters.endingDate;

      try {
        const { data } =
          await ApiIndicesPerformanceSummary.getIndicesPerformanceSummary(
            metric,
            endingDate
          );
        const decryptedData = IndicesPerformanceSummaryActions.decryptData(
          data.data
        ) as {
          indices: IndicesPerformanceSummaryState["indicesSummaryData"]["data"];
          endDate: string;
        };
        return {
          data: decryptedData.indices,
          metric: filters.selectedMetric,
          endingDate: decryptedData.endDate,
        };
      } catch (error) {
        console.log("getIndicesComparisonData Error: ", error);
        return rejectWithValue(error);
      }
    }
  );
}

export default IndicesPerformanceSummaryActions;
